
import { useSelector } from 'react-redux'
import Nav from './NavBar'


export default function Layout(props) {
  const { sidebar } = useSelector(state => state.misc)



  return (
    <div className="bg-grey h-screen overflow-x-hidden">
      <Nav />

      <main className={`w-full mx-auto pt-20 pb-10 col-span-4 trans px-5 ${sidebar ? 'md:pl-72' : 'md:pl-24'}`}>
        {props.children}
      </main>
    </div>
  )
}
